import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'component/utils/Select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class MissionSelect extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      missions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user } = this.props

    this.setState({ loading: true })

    return new Api(user.dsToken)
      .get(API_URL.MISSION_LIST)
      .then((response) => this.onFetchSuccess(response.data))
      .catch((error) => this.onFetchError(error))
  }

  onFetchSuccess(missions) {
    this.setState({ missions, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, missions: [] })
  }

  renderOptions(mission, index) {
    return (
      <option key={index} value={mission.cdMission}>
        {mission.dsMission}
      </option>
    )
  }

  render() {
    const { name, value, onChange, translate } = this.props
    const { missions, loading } = this.state

    const label = loading
      ? translate('loading')
      : translate('mission-edit.choose-mission')

    return (
      <Select
        id='idMission'
        name={name}
        label={label}
        value={value}
        onChange={(event) => onChange(event)}
      >
        <option value='' />

        {missions.map(this.renderOptions)}
      </Select>
    )
  }
}

export default MissionSelect
